export { ReceiptPage as default } from './ReceiptPage';
